import { useMemo } from "react";
import { isManualAccountV1 } from "../../Accounts/utilities/accountUtil";
import useExternalAccount from "./useExternalAccount";
import usePlaidInstitution from "./usePlaidInstitution";
import usePlaidLink from "./usePlaidLink";
/**
 * @returns An unmodified Manual Account, or a Plaid account that is hydrated with its Link and Institution
 */
const useExternalAccountExtended = (accountId, config) => {
    const externalAccount = useExternalAccount(accountId, config);
    const institutionId = useMemo(() => {
        if (externalAccount.isLoading || externalAccount.hasError) {
            return null;
        }
        if (isManualAccountV1(externalAccount.data.account)) {
            return null;
        }
        return externalAccount.data.account.details.institutionId;
    }, [
        externalAccount.data?.account,
        externalAccount.hasError,
        externalAccount.isLoading,
    ]);
    const linkId = useMemo(() => {
        if (externalAccount.isLoading || externalAccount.hasError) {
            return null;
        }
        if (isManualAccountV1(externalAccount.data.account)) {
            return null;
        }
        return externalAccount.data.account.details.linkId;
    }, [
        externalAccount.data?.account,
        externalAccount.hasError,
        externalAccount.isLoading,
    ]);
    const plaidInstitution = usePlaidInstitution(institutionId, config);
    const plaidLink = usePlaidLink(linkId, config);
    return useMemo(() => {
        if (externalAccount.isLoading || externalAccount.hasError) {
            return externalAccount;
        }
        if (isManualAccountV1(externalAccount.data.account)) {
            return {
                ...externalAccount,
                data: externalAccount.data.account,
            };
        }
        if (plaidInstitution.isLoading || plaidInstitution.hasError) {
            return plaidInstitution;
        }
        if (plaidLink.isLoading || plaidLink.hasError) {
            return plaidLink;
        }
        return {
            data: {
                ...externalAccount.data.account,
                institution: plaidInstitution.data.institution,
                link: plaidLink.data,
            },
            isLoading: false,
            hasError: false,
        };
    }, [externalAccount, plaidInstitution, plaidLink]);
};
export default useExternalAccountExtended;
//# sourceMappingURL=useExternalAccountExtended.js.map